import { getImageSize } from '@/libs/utils/docxUtils'
import { AlignmentType, ImageRun, Paragraph, TextRun, PageBreak } from 'docx'

const Chapter4Sub1Page = async ({ donutChartImg }) => {
  try {
    if (!donutChartImg) {
      throw new Error('No image data provided for donut chart.')
    }

    const { width, height } = await getImageSize({ image: donutChartImg, width: 550 })

    return [
      new Paragraph({ children: [new PageBreak()] }),
      new Paragraph(''),
      new Paragraph({
        children: [
          new TextRun({
            text: '\t',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
          new TextRun({
            text: '依受測者釣中行為進行「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」等多重釣中行為進行統計，並以各類行為之釣中人數比例繪製下列圓環圖 ：',
            font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
            size: 24,
          }),
        ],
      }),
      new Paragraph(''),
      new Paragraph(''),
      new Paragraph({
        alignment: AlignmentType.CENTER,
        // spacing: { before: pixelToDxa(30), after: pixelToDxa(30) },
        children: [
          new ImageRun({
            data: donutChartImg,
            transformation: {
              width,
              height,
            },
          }),
        ],
      }),
    ]
  } catch (error) {
    console.error('Error generating Word document:', error)
    return []
  }
}

export default Chapter4Sub1Page
